<div class="flex flex-row justify-between items-center mb-2">
    <h4 class="mb-0">{{ text }}</h4>
    <div class="flex flex-row gap-2">
        <ng-content select="[buttons]"></ng-content>
    </div>
</div>
